/**
 * Document types the generator will support. Values only — every behavior
 * attached to a type (canvas size, category tree, intelligence) arrives in
 * later phases. Order matches the product spec and is what the dropdown renders.
 */

export const DOCUMENT_TYPES = [
  'Instagram Post',
  'Instagram Story',
  'Facebook Post',
  'Meme',
  'YouTube Thumbnail',
  'YouTube Banner',
  'Flyer',
  'Poster',
  'Brochure',
  'Pamphlet',
  'Menu',
  'Logo',
  'Business Card',
  'Presentation',
  'Infographic',
  'Invitation',
  'Certificate',
  'Gift Certificate',
  'Banner',
  'Email Header',
  'Biodata',
  'Other',
];
